import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Navbar.css";
import ReorderIcon from '@mui/icons-material/Reorder';

function Navbar() {
  const [expandNavbar, setExpandNavbar] = useState(false);

  const location = useLocation();

  useEffect(() => {
    setExpandNavbar(false);
  }, [location]);

  return (
    <div className="navbar" id={expandNavbar ? "open" : "close"}>
      <div className="toggleButton">
        <button
          onClick={() => {
            setExpandNavbar((prev) => !prev);
          }}
        >
          <ReorderIcon />
        </button>
      </div>
      <div className="links">
        <Link to="/" className={location.pathname === "/" ? "active" : ""}> Home </Link>
        <Link to="/about" className={location.pathname === "/about" ? "active" : ""}> About </Link>
        <Link to="/experience" className={location.pathname === "/experience" ? "active" : ""}> Experience </Link>
        <Link to="/projects" className={location.pathname === "/projects" || location.pathname.startsWith("/project/") ? "active" : ""}> Projects </Link>
      </div>
    </div>
  );
}

export default Navbar;
